import { Injectable } from '@angular/core';

@Injectable()
export class SelectedNavContextService {
  private _title: string;
  private _reference: any;
  private _currentReference: any;
  private _partialHistory: string[] = [];
  private _backUrl: string;
  private _backOptions: any;

  get title(): string {
    return this._title;
  }

  get reference(): string {
    return this._reference;
  }

  set title(title: string) {
    this._title = title;
    this._reference = this._currentReference;
  }

  get currentReference(): any {
    return this._currentReference;
  }

  set currentReference(reference: any) {
    this._currentReference = reference;
  }

  get isReferenceChanged(): boolean {
    return this._reference !== this._currentReference;
  }

  get backUrl(): string {
    return this._backUrl;
  }

  set backUrl(url: string) {
    this._backUrl = url;
  }

  get backOptions(): any {
    return this._backOptions;
  }

  set backOptions(options: any) {
    this._backOptions = options;
  }

  get partialHistory(): string[] {
    return this._partialHistory || [];
  }

  addHistory(url: string) {
    this._partialHistory.push(url);
  }

  clearHistory() {
    while (this._partialHistory.length > 0) this._partialHistory.pop();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/context-menu/nav.context.service.ts